import { useEffect } from "react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";

export default function PlaybookDownload() {
  useEffect(() => {
    window.location.replace(`${API}/public/playbook/download`);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center" style={{background:"#050816",color:"white",fontFamily:"Manrope,system-ui,sans-serif"}}>
      <div>
        <img src="/ranktrust-logo.png?v=5" alt="RankTrust.io" className="h-10 w-auto mx-auto" />
        <h1 className="mt-8 text-3xl font-black">Opening Your Playbook…</h1>
        <p className="mt-3 text-white/60">Your Service Business Opportunity Playbook is being prepared.</p>
        <p className="mt-6 text-sm text-white/45">If the download does not begin, <Link to="/playbook" className="underline text-white/70">return to the Playbook page</Link>.</p>
      </div>
    </div>
  );
}
